"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgInWarning = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgInWarning = function SvgInWarning(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 0C4.47254 0 0 4.47293 0 10C0 15.5275 4.47293 20 10 20C15.5275 20 20 15.5271 20 10C20 4.47254 15.5271 0 10 0ZM10 18.4375C5.33621 18.4375 1.5625 14.6635 1.5625 10C1.5625 5.33621 5.33652 1.5625 10 1.5625C14.6638 1.5625 18.4375 5.33652 18.4375 10C18.4375 14.6638 14.6635 18.4375 10 18.4375Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 5.03426C9.56852 5.03426 9.21875 5.38402 9.21875 5.81551V10.8465C9.21875 11.278 9.56852 11.6277 10 11.6277C10.4315 11.6277 10.7812 11.278 10.7812 10.8465V5.81551C10.7812 5.38402 10.4315 5.03426 10 5.03426Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 14.6938C10.5825 14.6938 11.0547 14.2216 11.0547 13.6391C11.0547 13.0566 10.5825 12.5844 10 12.5844C9.41751 12.5844 8.94531 13.0566 8.94531 13.6391C8.94531 14.2216 9.41751 14.6938 10 14.6938Z",
    fill: "currentColor"
  }));
};

exports.SvgInWarning = SvgInWarning;